export const HTTPS_OK = 200;
export const HTTPS_UNAUTHORIZED = 401;
export const HTTPS_INTERNAL_SERVER_ERROR = 500;
export const HTTPS_BAD_REQUEST = 400;
